class WebSocketService {
  constructor() {
    this.socket = null;
    this.listeners = {};
  }

  connect(url) {
    if (this.socket) return;
    this.socket = new WebSocket(url);

    this.socket.onopen = () => {
      console.log("WebSocket connected");
      const message = {
        Type: "connect",
        Data: "Client connected"
      };
      this.socket.send(JSON.stringify(message));
    };




    this.socket.onmessage = (event) => {
      let data;
      try {
        data = JSON.parse(event.data);
       //  console.log("[WS] Received JSON:", data); // 🔍 προσθήκη
      } catch {
       // console.log("[WS] Received raw data:", event.data); // 🔍 προσθήκη
        data = event.data;
      }
      if (data && data.type && this.listeners[data.type]) {
        this.listeners[data.type].forEach(cb => cb(data));
      }
    };

    this.socket.onclose = () => {
    //  console.log("WebSocket disconnected");
      this.socket = null;
    };

    this.socket.onerror = (err) => {
      console.error("WebSocket error:", err);
    };
  }
  send(type, data) {
    if (this.socket && this.socket.readyState === WebSocket.OPEN) {
      this.socket.send(JSON.stringify({ type, ...data }));
    }
  }
  sendByObject(sendObject) {
    if (this.socket && this.socket.readyState === WebSocket.OPEN) {
      this.socket.send(JSON.stringify(sendObject));
    }
  }

  addEventListener(eventType, callback) {
    if (this.socket) {
      this.socket.addEventListener(eventType, callback);
    } else {
     // console.warn("WebSocket not connected, can't add event listener");
    }
  }

  removeEventListener(eventType, callback) {
    if (this.socket) {
      this.socket.removeEventListener(eventType, callback);
    }
  }


  on(type, callback) {
    if (!this.listeners[type]) this.listeners[type] = [];
    this.listeners[type].push(callback);
  }

  off(type, callback) {
    if (this.listeners[type]) {
      this.listeners[type] = this.listeners[type].filter(cb => cb !== callback);
    }
  }

  close() {
    if (this.socket) {
      this.socket.close();
      this.socket = null;
    }
  }
}

const webSocketService = new WebSocketService();
export default webSocketService;